import { connect } from 'react-redux'
import EkgReviewEkgRecording from './EkgReviewEkgRecording'
import { withRouter } from 'react-router-dom'
import {
  setInitialEkgReviewEkgRecordingData,
  clearSelectedRecordingId,
  clearSelectedReassignInboxId,
  updateSelectedReassignInboxId,
  removeFromStackCallback,
  confirmAndArchiveCallback,
  reassignCallback,
} from './module'

const mapActionCreators = {
  setInitialEkgReviewEkgRecordingData,
  clearSelectedRecordingId,
  clearSelectedReassignInboxId,
  updateSelectedReassignInboxId,
  removeFromStackCallback,
  confirmAndArchiveCallback,
  reassignCallback,
}

const mapStateToProps = state => ({
  selectedRecordingId: state.ekgReviewEkgRecording.selectedRecordingId,
  selectedReassignInboxId: state.ekgReviewEkgRecording.selectedReassignInboxId,
  selectedInboxId: state.ekgReviewEkgRecording.selectedInboxId,
  recordingIds: state.ekgReviewEkgRecording.recordingIds,
})

export default withRouter(
  connect(
    mapStateToProps,
    mapActionCreators
  )(EkgReviewEkgRecording)
)



// WEBPACK FOOTER //
// ./src/legacy/pages/EkgReviewEkgRecording/container.js